import './StandardPortfolio.scss';
import ActionItems from '../ActionItems/ActionItems';
import Portfolio from "../../core/enums/Portfolio";
import { IProps } from "../../App";
import ResumeSection, { ResumeSectionData } from './ResumeSection/ResumeSection';
import resumeData from '../../data/resume.json';

interface ResumeHeader {
  name: string;
  title: string;
  email?: string;
  phone?: string;
  location?: string;
  linkedin?: string;
  github?: string;
}

interface ResumeData {
  header: ResumeHeader;
  sections: ResumeSectionData[];
}

const resume = resumeData as ResumeData;

const StandardPortfolio = (props: IProps) => {
  return (
    <div className="standard-portfolio">
      <div className="resume">
        <header className="resume-header">
          <h1 className="resume-name">{resume.header.name}</h1>
          <p className="resume-title">{resume.header.title}</p>
          <div className="contact-info">
            {resume.header.email && <span>{resume.header.email}</span>}
            {resume.header.phone && <span>{resume.header.phone}</span>}
            {resume.header.location && <span>{resume.header.location}</span>}
            {resume.header.linkedin && <span>{resume.header.linkedin}</span>}
            {resume.header.github && <span>{resume.header.github}</span>}
          </div>
        </header>
        {resume.sections.map((section, i) => (
          <ResumeSection key={i} section={section} />
        ))}
      </div>
      <ActionItems
        changeLocation={props.changeLocation}
        location={Portfolio.Standard}
      />
    </div>
  );
}

export default StandardPortfolio;
